module.exports = __webpack_public_path__ + "pc/img/zhushou.43aa67a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rightNav/zhushou.jpg
// module id = 5N/M
// module chunks = 3